import { render, staticRenderFns } from "./ConfirmDeleteTabItemModal.vue?vue&type=template&id=2e79707e&"
import script from "./ConfirmDeleteTabItemModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmDeleteTabItemModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports